<template>
  <div class="layout-shell">
    <aside class="layout-aside">
      <div style="padding:24px 20px;font-size:20px;font-weight:600;">管理员后台</div>
      <el-menu
        background-color="#1f2d3d"
        text-color="#fff"
        active-text-color="#409EFF"
        :default-active="$route.path"
        router
      >
        <el-menu-item index="/admin/suppliers">供应商管理</el-menu-item>
        <el-menu-item index="/admin/circles">社团管理</el-menu-item>
        <el-menu-item index="/admin/companies">企业管理</el-menu-item>
        <el-menu-item index="/admin/segments">号段管理</el-menu-item>
        <el-menu-item index="/admin/sns">已签发 SN</el-menu-item>
      </el-menu>
    </aside>
    <main class="layout-main">
      <div class="layout-header">
        <div>欢迎，{{ name }}</div>
        <el-button @click="logout">退出登录</el-button>
      </div>
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  computed: {
    name() {
      return localStorage.getItem('name') || '管理员'
    },
  },
  methods: {
    logout() {
      localStorage.clear()
      this.$router.replace('/login')
    },
  },
}
</script>
